import React from "react";
import { observer } from "mobx-react-lite";
import {useStores} from "../hooks/useStores";

const PreviewUnlockButton = observer((props) => {
    const {ImageStore} = useStores();

    return <button onClick={() => {ImageStore.unlockPreviewImage()}}>unlock preview</button>
});

export default PreviewUnlockButton;